import styled, { Scale, keyframes } from '@secretescapes/falcon';
import { CALENDAR_DAY_DIMENSIONS_PX } from '@features/AvailabilityPresentation/AvailabilityPresentation.utils';
import { Bar } from '@features/AvailabilityPresentation/LoadingSkeleton/LoadingSkeleton';

// This is the width of the calendar day, minus the border on each side
// Multiplication value increases the shimmer speed
const CALENDAR_ANIMATION_SIZING = (CALENDAR_DAY_DIMENSIONS_PX - 2) * 3;

const calendarLoadingAnimation = keyframes`
  100% {
    background-position: ${CALENDAR_ANIMATION_SIZING}px;
  }
`;

export const ContentLoading = styled(Bar)`
  border-radius: ${Scale.xxs};
  background-color: ${({ theme }) => theme?.color?.grey05};
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme?.color?.grey05} 25%,
    ${({ theme }) => theme?.color?.white} 50%,
    ${({ theme }) => theme?.color?.grey05} 75%
  );
  background-repeat: 'repeat';
  animation-name: ${calendarLoadingAnimation};
`;

export const Content = styled('div')`
  border-radius: ${Scale.xxs};
`;
